import {Component, Fragment} from 'react';
import {formatMoney} from 'accounting';
import injectSheet from 'react-jss';
import {getIncome} from '@deliveriesondemand/dod-utils';

import CreditorService from '-/services/CreditorService';
import {rem} from '-/styles/utils';
import {get, isFinite} from '-/util/lodash';

const styles = () => ({
    container: {
        padding: 20,
        marginBottom: 40,
        borderWidth: 5,
        borderColor: 'black',
        borderStyle: 'solid',
        backgroundColor: '#fff'
    },
    h1: {
        fontSize: rem(18),
        fontWeight: 'bold',
        marginTop: 0
    },
    grossIncome: {
        fontSize: rem(40),
        marginTop: rem(10),
        marginBottom: rem(15)
    },
    p: {
        textAlign: 'center',
        lineHeight: rem(30)
    }
});

class LowIncomeWarning extends Component {
    constructor(props) {
        super(props);

        this.state = {
            adjustedTotalGrossMonthly: null,
            threshold: null,
            showWarning: false
        };
    }

    componentDidMount() {
        // TODO: Instead of determining visibility here, we should move these calculations to the parent
        // and short circuit the component as needed.  We will also need to pass the threshold & adjusted total gross.

        const {offer = {}, onLowIncomeWarning} = this.props;
        const {app} = getIncome(offer);
        const {totalGrossMonthly = 0} = app;
        const threshold = CreditorService.getGrossIncomeThreshold();

        if (!isFinite(threshold)) {
            return null;
        }

        const meetsThreshold = totalGrossMonthly > threshold;
        const showWarning = isFinite(totalGrossMonthly) && !meetsThreshold;

        this.setState({
            adjustedTotalGrossMonthly: totalGrossMonthly,
            threshold,
            showWarning
        });

        if (showWarning) {
            onLowIncomeWarning();
        }
    }

    render() {
        const {classes = {}, contactPhone, isCCRMode} = this.props;
        const {adjustedTotalGrossMonthly, showWarning, threshold} = this.state;

        if (!showWarning) {
            return null;
        }

        return (
            <Fragment>
                {isCCRMode ? (
                    <div className={classes.container}>
                        <h1 className={classes.h1}>Low Gross Monthly Income Warning</h1>
                        <h1 className={classes.grossIncome}>{formatMoney(adjustedTotalGrossMonthly)}</h1>
                        <p className={classes.p}>Applicant makes below {formatMoney(threshold)}.</p>
                        <p className={classes.p}>You will need a co-applicant for this applicaton.</p>
                    </div>
                ) : (
                    <div className={classes.container}>
                        <p className={classes.p}>
                            Thank you for completing the application thus far. We have
                            determined that you may need a co-applicant to proceed. If
                            you have any questions or believe this to be an error please
                            call {contactPhone} to speak to one of our representatives.
                        </p>
                    </div>
                )}
            </Fragment>
        );
    }
}

export default injectSheet(styles)(LowIncomeWarning);
